import { render, staticRenderFns } from "./QuotaShotList.vue?vue&type=template&id=08efedbe&scoped=true&"
import script from "./QuotaShotList.vue?vue&type=script&lang=js&"
export * from "./QuotaShotList.vue?vue&type=script&lang=js&"
import style0 from "./QuotaShotList.vue?vue&type=style&index=0&id=08efedbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08efedbe",
  null
  
)

export default component.exports